import React, { useEffect, useState } from 'react';
import { IUserDataCommandCenterProps } from '@/types/Achievements';
import { useStore } from '@/zustand/store/store';
import api from '../../../api/services/achievements';
import ArmiesSection from './ArmiesSection';
import UserDataSection from './UserDataSection';
import UserWalletDataSection from './UserWalletDataSection';
import useAuthStatuses from '@/hooks/authentication/useAuthStatuses';

const LeftBox = ({ onClick }) => {
  const [userData, setUserData] = useState<IUserDataCommandCenterProps>();
  const { isLogin } = useAuthStatuses();
  const {
    showPointList,
    refetchUserData,
    setShowPointList,
    setRankConfig,
    commandSocketData: { stateChanged },
  } = useStore();

  const getData = () => {
    api.userDataCommandCenter().then((res) => {
      setUserData(res.data.data);
      setRankConfig({ ranks: res.data.data.rank_config, currentPoint: res.data.data.user_xp });
    });
  };

  useEffect(() => {
    if (stateChanged || refetchUserData) {
      getData()
    }
  }, [stateChanged, refetchUserData]);

  useEffect(() => {
    if (isLogin) {
      getData();
    }
  }, [isLogin]);

  return (
    <div className='w-full lg:w-[200px] h-auto lg:h-[calc(100vh-80px)] left-0 top-[70px]  sticky flex flex-col gap-y-2'>
      <div className='h-auto lg:h-[380px] w-full flex flex-col gap-y-2'>
        <div
          className='h-[175px] bg-[#3C3B3B] bg-opacity-40 rounded-[10px] w-full pt-2 px-4 mb-2 lg:mb-0 flex justify-center items-center'
          onClick={async () => {
            if (isLogin) {
              await setShowPointList(!showPointList);
              onClick();
            }
          }}
        >
          <UserDataSection userData={userData} />
        </div>
        <div className='h-[calc(100%-115px)] bg-[#3C3B3B] bg-opacity-40 rounded-[10px] w-full hidden lg:flex justify-center items-center'>
          <UserWalletDataSection userData={userData} />
        </div>
      </div>
      <div className='bg-[#3C3B3B] bg-opacity-40 rounded-[10px] h-[calc(100%-310px)] p-[10px] hidden lg:flex flex-col'>
        <ArmiesSection />
      </div>
    </div>
  );
};

export default LeftBox;
